import { CATEGORIES } from './constants/category';
import { CIDS } from '../components/ProductsTable/constants';

const taxonomiesWithLinkChanges = [
	{
		taxonomy: CATEGORIES.IMAGE_SENSORS,
		oldFilters: [CIDS.MEGAPIXELS]
	},
	{
		taxonomy: CATEGORIES.MOSFET,
		oldFilters: [
			CIDS.FIVE_VOLT_LOGIC,
			CIDS.PACKAGE_TYPE,
			CIDS.OLD_ON_DS_RESISTANCE_TYPICAL_FOR_VGS_10V,
			CIDS.OLD_GATE_CHARGE_FOR_VGS_10
		]
	},
	{
		taxonomy: CATEGORIES.GATE_DRIVER,
		oldFilters: [CIDS.TYPE_OF_POWER_SWITCH]
	}
];

export const checkIfLinkNeedConversion = (categoryId, currentFilters) => {
	const taxonomyForConversion = taxonomiesWithLinkChanges.filter(tax => tax.taxonomy === categoryId);
	if (taxonomyForConversion.length === 0) return false;
	const oldFilters = taxonomyForConversion[0].oldFilters;
	return oldFilters.some(oldFilter => {
		if (currentFilters[oldFilter]) {
			return true;
		}
		return false;
	});
};

export const covertOldParameterToNew = (categoryId, currentFilters) => {
	if (categoryId === CATEGORIES.MOSFET) {
		if (currentFilters[CIDS.FIVE_VOLT_LOGIC] === 'true') {
			delete currentFilters[CIDS.FIVE_VOLT_LOGIC];
			currentFilters[CIDS.GATE_LEVEL] = '(Logic)';
		}
		if (currentFilters[CIDS.PACKAGE_TYPE]) {
			const oldValues = customStringValueDecode(currentFilters[CIDS.PACKAGE_TYPE]).slice(1, -1).split(';');
			let newValues = [];
			oldValues.forEach(v => {
				if (mosfetPackageConversion().get(v)) {
					newValues.push(...mosfetPackageConversion().get(v));
				}
			});

			if (newValues.length > 0) {
				delete currentFilters[CIDS.PACKAGE_TYPE];
				newValues = [...new Set(newValues)];
				currentFilters[CIDS.NEW_MOSFET_PACKAGE_TYPE] = customStringValueEncode('(' + newValues.join(';') + ')');
			}
		}
		if (currentFilters[CIDS.OLD_ON_DS_RESISTANCE_TYPICAL_FOR_VGS_10V]) {
			const oldValue = currentFilters[CIDS.OLD_ON_DS_RESISTANCE_TYPICAL_FOR_VGS_10V];
			delete currentFilters[CIDS.OLD_ON_DS_RESISTANCE_TYPICAL_FOR_VGS_10V];
			currentFilters[CIDS.ON_STATE_DS_RESISTANCE_TYP] = oldValue;
		}
		if (currentFilters[CIDS.OLD_GATE_CHARGE_FOR_VGS_10]) {
			const oldValue = currentFilters[CIDS.OLD_GATE_CHARGE_FOR_VGS_10];
			delete currentFilters[CIDS.OLD_GATE_CHARGE_FOR_VGS_10];
			currentFilters[CIDS.GATE_CHARGE_TYP] = oldValue;
		}
	}
	if (categoryId === CATEGORIES.IMAGE_SENSORS) {
		if (currentFilters[CIDS.MEGAPIXELS] && !isNaN(+currentFilters[CIDS.MEGAPIXELS])) {
			const oldValue = currentFilters[CIDS.MEGAPIXELS];
			delete currentFilters[CIDS.MEGAPIXELS];
			currentFilters[CIDS.MEGAPIXELS] = `(${oldValue};44.7)`;
		}
	}
	if (categoryId === CATEGORIES.GATE_DRIVER && currentFilters[CIDS.TYPE_OF_POWER_SWITCH]) {
		const oldValues = customStringValueDecode(currentFilters[CIDS.TYPE_OF_POWER_SWITCH]).slice(1, -1).split(';');

		const valueToChange = 'MOSFET / IGBT';
		if (oldValues.includes(valueToChange)) {
			const newValues = oldValues.flatMap(v => (v === valueToChange ? ['MOSFET', 'IGBT'] : [v]));

			if (newValues.length > 0) {
				delete currentFilters[CIDS.TYPE_OF_POWER_SWITCH];
				const uniqueValues = [...new Set(newValues)];
				currentFilters[CIDS.TYPE_OF_POWER_SWITCH] = customStringValueEncode('(' + uniqueValues.join(';') + ')');
			}
		}
	}
	return currentFilters;
};

const customStringValueDecode = stringValue => {
	return stringValue.trim().replace(/_/g, ' ').replace(/~/g, ',');
};

const customStringValueEncode = stringValue => {
	return stringValue.replace(/\s/g, '_').replace(/,/g, '~');
};

const mosfetPackageConversion = () => {
	const map = new Map();

	map.set('ChipFET-8', ['CHIPFET-8']);
	map.set('CPH-3', ['CPH-3']);
	map.set('CPH-6', ['SC-6']);
	map.set('CSP-4', ['WLCSP']);
	map.set('CSP-6', ['WLCSP']);
	map.set('D2PAK-3 / TO-263-2', ['D2PAK']);
	map.set('D2PAK7 (TO-263-7L HV)', ['D2PAK7', 'D2PAK7 (TO-263-7L HV)']);
	map.set('D2PAK7 (TO-263-7LD) 15.4x9.9x4.5', ['D2PAK7']);
	map.set('D2PAK-7 / TO-263-7', ['D2PAK7']);
	map.set('DFN5 5x6, 1.27P', ['Power 56 (SO-8FL)']);
	map.set('DFN5 5x6, 1.27P (SO−8FL)', ['Power 56 (SO-8FL)']);
	map.set('DFN-6', ['DFN-6']);
	map.set('DFN-8', ['Power 56 Dual Cool', 'Power 56 (SO-8FL)', 'Power 33 (u8FL)']);
	map.set('DFNW5 5x6', ['Power 56 (SO-8FL)']);
	map.set('DFNW5 5x6 (FULL-CUT SO8FL WF)', ['Power 56 (SO-8FL)']);
	map.set('DFNW5 5x6, FULL−CUT SO8FL WF', ['Power 56 (SO-8FL)']);
	map.set('DFNW-8', ['Power 88', 'Power 56 (SO-8FL)', 'Power 88 Dual Cool']);
	map.set('DPAK (Single Gauge) / ATPAK', ['DPAK']);
	map.set('DPAK INSERTION MOUNT', ['DPAK-3']);
	map.set('DPAK-3', ['DPAK-3', 'DPAK']);
	map.set('DPAK-3 / TO-252-3', ['TO-252-3', 'DPAK']);
	map.set('H-PSOF8L 9.90x11.68, 1.20P', ['Power 1012 (TOLL)', 'H-PSOF8L 9.90x10.38x2.30, 1.20P']);
	map.set('I2PAK-3 / D2PAK-3 STRAIGHT LEAD', ['D2PAK']);
	map.set('IPAK-3 / DPAK-3 STRAIGHT LEAD', ['DPAK']);
	map.set('LFPAK-4', ['Power 56 LFPAK']);
	map.set('LFPAK-8', ['Power 56 LFPAK']);
	map.set('LFPAK8 3.3x3.3, 0.65P', ['Power 33 LFPAK']);
	map.set('LFPAK8 5.15x6.15', ['Power 56 LFPAK']);
	map.set('PQFN-4', ['Power 88']);
	map.set('PQFN-6', ['Power 22']);
	map.set('PQFN-8', ['Power 56 (SO-8FL)', 'Power 33 (u8FL)', 'Power 33 Dual Cool', 'Power 88 Dual Cool']);
	map.set('SC-70-3 / SOT-323-3', ['SC-3']);
	map.set('SC-70FL / MCPH-3', ['MCPH-3']);
	map.set('SC-74', ['SC-6']);
	map.set('SC-75-3', ['SC-3']);
	map.set('SC-88-6 / SC-70-6 / SOT-363-6', ['SC-6']);
	map.set('SC-88FL / MCPH-6', ['SC-6']);
	map.set('SC-89-3', ['SC-3']);
	map.set('SO-8FL / DFN-5', ['Power 56 (SO-8FL)', 'DFN-5']);
	map.set('SO-8FL Dual / DFN-8', ['Power 56 (SO-8FL)']);
	map.set('SOIC-8', ['SOIC-8', 'SOIC-8N']);
	map.set('SOT-1123-3', ['SOT-1123-3']);
	map.set('SOT-223-4 / TO-261-4', ['SC-4']);
	map.set('SOT-223-4 / TO-261-4D', ['SC-4']);
	map.set('SOT-23 (TO-236)', ['SOT-23']);
	map.set('SOT-23-3', ['SOT-23']);
	map.set('SOT-28 FL / ECH-8', ['Power 33']);
	map.set('SOT-28FL / VEC-8', ['SOT-28FL-8']);
	map.set('SOT-383FL / EMH-8', ['SOT-383FL-8']);
	map.set('SOT-523FL', ['SC-3']);
	map.set('SOT-563', ['SC-6']);
	map.set('SOT-723-3', ['SC-3']);
	map.set('SOT-883', ['DFN-3']);
	map.set('SOT-963', ['SC-6']);
	map.set('TCPAK10 5.1x7.5, 1.0P', ['Power 56 TCPAK', 'Power 1012 TCPAK']);
	map.set('TDFN4 8x8, 2P', ['Power 88', 'TDFN4 8x8, 2P']);
	map.set('TDFN9 5x6, 1.27P', ['Power 56 Source Down']);
	map.set('TO-220 FULLPACK, 3-LEAD (ULTRA NARROW LEAD)', ['TO-220']);
	map.set('TO-220-3', ['TO-220', 'TO-220-3']);
	map.set('TO-220-3 FullPak', ['TO-220FP']);
	map.set('TO-247 4-LEAD, THIN LEADS', ['TO-247-4']);
	map.set('TO-247-3', ['TO-247-3', 'TO-247']);
	map.set('TO-247-3LD', ['TO-247-3', 'TO-247', 'TO-247-3LD']);
	map.set('TO-247-4', ['TO-247-4', 'TO-247']);
	map.set('TO-264-3', ['TO-3']);
	map.set('TO-3P-3L', ['TO-3PN']);
	map.set('TO-3PF-3L', ['TO-3PF']);
	map.set('TO−92 3LD 4.75x4.80', ['TO-92-3']);
	map.set('TO-92-3', ['TO-92']);
	map.set('TO-92-3 LF', ['TO-92']);
	map.set('TO-LL 8L', ['Power 1012 (TOLL)']);
	map.set('TSOP-6', ['SC-6']);
	map.set('TSOT-23-6', ['SC-6']);
	map.set('UDFN-6', ['Power 22', 'Power 33']);
	map.set('WDFN-12', ['WDFN-12']);
	map.set('WDFN-6', ['Power 22', 'WDFN-6']);
	map.set('WDFN-8', ['Power 33 (u8FL)', 'Power 56 (SO-8FL)', 'Power 33']);
	map.set('WDFN-8 / u8FL', ['Power 33 (u8FL)']);
	map.set('WDFN9 3.3x3.3, 0.65P', ['Power 33 Source Down']);
	map.set('WDFNW6 2.05x2.05, 0.65P', ['Power 22']);
	map.set('WDFNW6 2.2x2.3, 0.8P', ['Power 22']);
	map.set('WDFNW8 3.30x3.30x0.75, 0.65P', ['Power 33 (u8FL)']);
	map.set('WDFNW8 3.3x3.3, 0.65P', ['Power 33 (u8FL)']);
	map.set('WDFNW8 3.3x3.3, 0.65P (Full−Cut 8FL WF)', ['Power 33 (u8FL)']);
	map.set('WLCSP10 2.98x1.49x0.1', ['WLCSP']);
	map.set('WLCSP-6', ['WLCSP']);
	map.set('WQFN-12', ['Power 33']);
	map.set('XDFN-3', ['XDFN-3']);
	map.set('XDFNW3 1x1, 0.65P', ['DFN-3']);
	map.set('XLLGA-3', ['SC-3']);
	map.set('XLLGA-6', ['SC-6']);

	return map;
};

const handleSlidersValues = (urlFilterValues, filter, currentFilters, key, values) => {
	if (!filter.constraints) {
		return;
	}
	const { maxValue, minValue, maxOperator, minOperator } = filter.constraints;

	if (maxOperator && minOperator) {
		setMinMaxValues(urlFilterValues, minValue, maxValue);
		currentFilters[key] = customStringValueEncode(`(${urlFilterValues.join(';')})`);
	} else {
		handleSingleSliderValue(values, minValue, maxValue, currentFilters, key);
	}
};

const setMinMaxValues = (urlFilterValues, minValue, maxValue) => {
	if (!urlFilterValues[0]) {
		urlFilterValues[0] = minValue;
	} else if (!urlFilterValues[1]) {
		urlFilterValues[1] = maxValue;
	}
	urlFilterValues[0] = Math.max(urlFilterValues[0], minValue);
	urlFilterValues[1] = Math.min(urlFilterValues[1], maxValue);
};

const handleSingleSliderValue = (values, minValue, maxValue, currentFilters, key) => {
	const numericValue = parseFloat(values);
	if (numericValue < minValue) {
		currentFilters[key] = minValue.toString();
	} else if (numericValue > maxValue) {
		currentFilters[key] = maxValue.toString();
	}
};

export const removeUnsupportedValuesFromFilters = (currentFilters, filtersOptions, filters) => {
	for (const [key, values] of Object.entries(currentFilters)) {
		const numberOfCharactersToSlice = values.startsWith('!') ? 2 : 1;
		const urlFilterValues = customStringValueDecode(values).slice(numberOfCharactersToSlice, -1).split(';');
		const filter = filters.find(filter => filter.cid === key);

		if (filter) {
			if (filter.type === 'N' && !filter.conditional) {
				handleSlidersValues(urlFilterValues, filter, currentFilters, key, values);
			} else {
				const newUrlFilterValues = urlFilterValues.filter(value => filtersOptions[key]?.includes(value));

				if (filtersOptions[key]) {
					delete currentFilters[key];
					if (newUrlFilterValues.length > 0) {
						const startForCurrentFilters = values.startsWith('!') ? '!(' : '(';
						currentFilters[key] = customStringValueEncode(startForCurrentFilters + newUrlFilterValues.join(';') + ')');
					}
				}
			}
		}
	}
	return currentFilters;
};
